import {Link} from 'react-router';
import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@ui/themes/use-is-dark-mode';
import authBgSvg from './auth-bg.svg';
import {useTrans} from '@ui/i18n/use-trans';
import {useSettings} from '@ui/settings/use-settings';
import {getAssetUrl} from '@ui/utils/urls/get-asset-url';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  hideLogo?: boolean;
  children: ReactNode;
}
export function AuthLayout({heading, children, message, hideLogo}: AuthPageProps) {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const {trans} = useTrans();
  const logoSrc = isDarkMode ? branding.logo_light : branding?.logo_dark;

  return (
    <main
      className="flex h-screen flex-col items-center overflow-y-auto bg-alt px-14 pt-70 dark:bg-none md:px-10vw"
      style={{backgroundImage: isDarkMode ? undefined : `url("${authBgSvg}")`}}
    >
      {!hideLogo && (
        <Link
          to="/"
          className="mb-40 block flex-shrink-0"
          aria-label={trans({message: 'Go to homepage'})}
        >
          {logoSrc && (
            <img
              src={getAssetUrl(logoSrc)}
              className="m-auto block h-42 w-auto"
              alt=""
            />
          )}
        </Link>
      )}
      <div className="mx-auto w-full max-w-440 rounded-lg bg px-40 pb-32 pt-40 shadow md:shadow-xl">
        {heading && <h1 className="mb-20 text-xl">{heading}</h1>}
        {children}
      </div>
      {message && <div className="mt-36 text-sm">{message}</div>}
      <AuthLayoutFooter />
    </main>
  );
}
